// Predictive Search — binds every [data-predictive-search-input] to the
// [data-predictive-search-results] container inside the same form/wrapper.
(function() {
  const inputs = document.querySelectorAll('[data-predictive-search-input]');
  if (!inputs.length) return;

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (c) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
  }

  // suggest.json returns prices as decimal strings in shop currency (e.g. "298.00")
  function formatMoney(price) {
    const n = parseFloat(price);
    if (Number.isNaN(n)) return '';
    return '£' + n.toFixed(2);
  }

  inputs.forEach((input) => {
    const wrapper = input.closest('form') || input.parentElement;
    const results = wrapper.querySelector('[data-predictive-search-results]')
      || (wrapper.parentElement && wrapper.parentElement.querySelector('[data-predictive-search-results]'));
    if (!results) return;

    let debounceTimer;

    async function search(query) {
      if (!query || query.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }

      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`);
        const data = await res.json();
        const products = data.resources.results.products || [];

        if (products.length === 0) {
          results.innerHTML = '<div class="predictive-search__empty">No products found</div>';
          results.hidden = false;
          return;
        }

        results.innerHTML = `
          <div class="predictive-search__results">
            ${products.map(product => `
              <a href="${product.url}" class="predictive-search__item">
                ${product.image ? `<img src="${product.image.replace(/(\.[^.]+)$/, '_60x$1')}" alt="${escapeHtml(product.title)}" class="predictive-search__image" loading="lazy">` : '<div class="predictive-search__image predictive-search__image--empty"></div>'}
                <div class="predictive-search__info">
                  <p class="predictive-search__title">${escapeHtml(product.title)}</p>
                  <p class="predictive-search__price">${formatMoney(product.price)}</p>
                </div>
              </a>
            `).join('')}
            <a href="/search?q=${encodeURIComponent(query)}" class="predictive-search__view-all">
              View all results for "${escapeHtml(query)}"
            </a>
          </div>
        `;
        results.hidden = false;
      } catch (err) {
        results.hidden = true;
      }
    }

    input.addEventListener('input', (e) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => search(e.target.value.trim()), 300);
    });

    input.addEventListener('focus', () => {
      if (input.value.trim().length >= 2) {
        results.hidden = false;
      }
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.site-header__search') && !e.target.closest('.mobile-menu__search')) {
        results.hidden = true;
      }
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        results.hidden = true;
        input.blur();
      }
    });
  });
})();
